"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSExemptionCheck_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NHSExemptionCheck_Factory = /** @class */ (function () {
    function NHSExemptionCheck_Factory() {
    }
    NHSExemptionCheck_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            ExemptionCheck: model.ExemptionCheck,
        };
        return result;
    };
    NHSExemptionCheck_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            ExemptionCheck: model.ExemptionCheck,
        };
        return result;
    };
    return NHSExemptionCheck_Factory;
}());
exports.NHSExemptionCheck_Factory = NHSExemptionCheck_Factory;
